import { render } from "./InvoiceListView.vue?vue&type=template&id=3f808f28&scoped=true"
import script from "./InvoiceListView.vue?vue&type=script&lang=js"
export * from "./InvoiceListView.vue?vue&type=script&lang=js"

import "./InvoiceListView.vue?vue&type=style&index=0&id=3f808f28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f808f28"]])

export default __exports__